import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";

export default function EmptyQueueHint({ discordInviteUrl }) {
  return (
    <Fade in timeout={400}>
      <Box
        sx={{
          textAlign: "center",
          py: 0.5,
          px: 2,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: "rgba(255, 255, 255, 0.45)",
            fontSize: "0.78rem",
          }}
        >
          No players searching right now — try during peak hours or{" "}
          <Box
            component="a"
            href={discordInviteUrl}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "#E8A33D",
              textDecoration: "none",
              "&:hover": { textDecoration: "underline" },
            }}
          >
            rally on Discord
          </Box>
        </Typography>
      </Box>
    </Fade>
  );
}
